<template>
    <div style="background-color: #f0f0f0">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="width: 100%;height: 140px;margin: 10px auto;background-color: white; ">
            <el-form :ref="form" :model="form" label-width="80px">
<!--style="border-top: 2px dashed #afafaf;padding-top: 20px;"-->
                <div  style="padding-top: 20px;padding-left: 20px">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="供应商名:"   >
                                <el-input size="small"v-model="form.searchStr" style="width: 320px;border: 0px;" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col >
                        <el-col :span="8">
                            <el-form-item label="联系人:" >
                                <el-input size="small" v-model="form.searchStr" style="width: 320px;border: 0px;" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="联系电话:" >
                                <el-input size="small" v-model="form.searchStr" style="width: 320px;border: 0px;" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item >
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item >
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item  style="float: right;padding-right: 10%">
                                <el-button size="small" @click="search" style="color:blue;width: 120px">重置</el-button>
                                <el-button size="small" type="primary" @click="search" style="width: 120px">搜索</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>




                </div>
            </el-form>
        </div>
        <!-- @command="batchHandle"-->
        <div style="width: 100%;margin: 0px;padding-bottom: 10px">

                <el-button type="warning" size="small" @click="dialogVisible=true" >添加供应商</el-button>
        </div>
<!--新建-->

        <el-dialog :close-on-click-modal="false"  
                title="添加供应商"
                :visible.sync="dialogVisible"
                width="45%"
                hight="50%"
                :before-close="handleClose">

            <el-form ref="form" :model="form" label-width="110px">

                <el-form-item label="供应商类型:">
                    <el-radio-group v-model="form.resource">
                        <el-radio v-model="radio"  label="1688供应商"></el-radio>
                        <el-radio v-model="radio"  label="其他供应商"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="供应商名称:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="联系人:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号码:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="电话号码:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="QQ:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="Email:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="网址:">
                    <el-input v-model="form.name" style="color: #cccccc" placeholder="请输入以http://或https://开头的URL"></el-input>
                </el-form-item>
                <el-form-item label="地址:">
                    <el-input type="textarea" v-model="form.desc"></el-input>
                </el-form-item>
                <el-form-item label="备注:">
                    <el-input type="textarea" v-model="form.desc"></el-input>
                </el-form-item>


                <!--<el-form-item label="活动时间">-->
                    <!--<el-col :span="11">-->
                        <!--<el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>-->
                    <!--</el-col>-->
                    <!--<el-col class="line" :span="2">-</el-col>-->
                    <!--<el-col :span="11">-->
                        <!--<el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>-->
                    <!--</el-col>-->
                <!--</el-form-item>-->

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                    <el-button  type="primary" @click="dialogVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           </span>
        </el-dialog>
<!--编辑-->
        <el-dialog :close-on-click-modal="false"  
                title="编辑"
                :visible.sync="edit"
                width="45%"
                hight="50%"
                :before-close="handleClose">


            <el-form ref="form" :model="form" label-width="110px">

                <el-form-item label="供应商名称:">
                    <el-input v-model="form.mc"></el-input>
                </el-form-item>
                <el-form-item label="供应商类型:">
                    <el-input v-model="form.lx"></el-input>
                </el-form-item>
                <el-form-item label="联系人:">
                    <el-input v-model="form.lxr1"></el-input>
                </el-form-item>
                <el-form-item label="联系方式:">
                    <el-input v-model="form.lxfs1"></el-input>
                </el-form-item>
                <el-form-item label="添加时间:">
                    <el-input v-model="form.tjsj"></el-input>
                </el-form-item>
                <el-form-item label="地址:">
                    <el-input type="textarea" v-model="form.dz1"></el-input>
                </el-form-item>
                <el-form-item label="备注:">
                    <el-input type="textarea" v-model="form.bz1"></el-input>
                </el-form-item>


                <!--<el-form-item label="活动时间">-->
                <!--<el-col :span="11">-->
                <!--<el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>-->
                <!--</el-col>-->
                <!--<el-col class="line" :span="2">-</el-col>-->
                <!--<el-col :span="11">-->
                <!--<el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>-->
                <!--</el-col>-->
                <!--</el-form-item>-->

                <el-form-item>
                    <el-button type="primary" @click="onSubmit2">提交</el-button>
                    <el-button  type="primary" @click="edit = false">取消</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           </span>
        </el-dialog>

        <div>
            <!--:span-method="arraySpanMethod"-->
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                      >
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <!--<el-table-column prop="img" label="图片" width="120" align="center">-->
                    <!--<template slot-scope="scope">-->
                        <!--<img :src="scope.row.img" width="40" height="40" />-->
                        <!--<span>{{scope.row.distiption}}</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column prop="title" label="供应商名称" width="120">
                </el-table-column>
                <el-table-column prop="gyslx"  label="供应商类型" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.gyslx"></div>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="bz" align="center"></el-table-column>
                <el-table-column label="联系人" prop="lxr" align="center"></el-table-column>
                <el-table-column label="联系方式" prop="lxfs" align="center"></el-table-column>
                <el-table-column label="地址" prop="dz" align="center"></el-table-column>
                <el-table-column prop="time" label="添加时间" align="center"></el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  type="primary" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                        <el-button  type="primary" size="mini" @click="bj(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <el-pagination background style="float: right;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
                           :total="400">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CollectionBox",
        data() {
            return {
                currentPage: 1,
                form: {
                    searchStr: null,
                    searchType: []
                },
//                dpList: ["店铺1", "店铺2", "店铺3", "店铺4", "店铺5", "店铺6", "店铺7", ],
                tableData: [{
                    title: '桂林渔具厂',
                    gyslx: '淘宝供应商',
                    bz: '优质供应商',
                    lxr: '猪小明',
                    lxfs: '123456789',
                    dz: '广西桂林',
                    time: '2020-09-01',
                    id: 1
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 2
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 3
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 4
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 5
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 6
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 7
                },{
                    title: '肃宁县翔锐渔具厂',
                    gyslx: '1688供应商',
                    bz: '优质供应商',
                    lxr: '林小明',
                    lxfs: '123456789',
                    dz: '广州珠江新城开发区',
                    time: '2020-09-01',
                    id: 8
                }],
                spanArr: [],
                dialogVisible: false,
                edit:false,
                form: {
                    mc: '',
                    lx: '',
                    lxr1: '',
                    lxfs1: '',
                    dz1: '',
                    tjsj: '',
                    bz1: ''
                },
//                innerTableData:[],
//                innerData: [
//                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
//                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'}
//                ],
            }
        },
//        created() {
//            var tabHtml ='<table class="innerTab" style="width: 100%">'
//            this.innerData.forEach((item,index)=>{
//                tabHtml += `<tr>
//					<td >`+item.sku +`</td>
//					<td >`+item.price +`</td>
//					<td >`+item.price_1 +`</td>
//					<td >`+item.rep +`</td>
//				</tr>`;
//            });
//            tabHtml += `</table><el-row class="tab_butt"><span>展开<i class="el-icon-caret-bottom"\></span></el-row>`;
//            this.tableData[0].sppr = tabHtml;
//        },
        methods: {
            search: function() {
                this.form.searchStr = "45649";
                alert("查询");
            },

            onSubmit() {
                alert("提交成功");
            },
            onSubmit2() {
                alert("提交成功");
            },
//            onSubmit2() {
//                alert("提交成功");
//            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            handleSelectionChange: function(val) {
                var ids = [];
                val.forEach((item) => {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                    }
                });
                this.$message({
                    message: '选择提示:已选择' + ids.length + '条',
                    center: true,
                    offset: 200
                });

            },
            //合并列
//            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
//                if (columnIndex === 3) {
//                    return [1, 4];
//                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
//                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
//                    return [0, 0];
//                }
//            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            bj(row) {
                alert(row.id);
                this.form.mc=row.title;
                this.form.lx=row.gyslx;
                this.form.lxr1=row.lxr;
                this.form.lxfs1=row.lxfs;
                this.form.dz1=row.dz;
                this.form.tjsj=row.time;
                this.form.bz1=row.bz;
                this.edit=true;
            },
//            addNote: function() {
//
//            },
            deleteRow(row) {
                alert(111);
                this.$confirm('确定要删除选中的商品吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }

        },
        mounted() {
            this.getSpanArr(this.tableData);
        }
    }
</script>

<style scoped>
    .innerTab td{
        text-align: center;
    }
    #outTable tr td:nth-child(4){
    }
    #outTable tr td:nth-child(4) .cell table{
        border-collapse:collapse !important;
    }
    #outTable tr td:nth-child(4) .cell table tr td{
        padding:4px 0 !important;
        width:25%;
        border-right: initial;
        border-bottom: 1px dashed #d67d5a ;
    }
    #outTable tr td:nth-child(4) .cell{
        /* border-collapse:collapse !important; */
    }
    .tab_butt{
        /* background-color: #4934b2; */
        width: 40%;
        cursor: pointer;
    }
    .el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #cccccc !important;
        line-height: 40px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
    }

</style>
